import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import miLogo from './assets/mi-logo.png'; 

const formatCurrency = (value) => {
    const number = parseFloat(value);
    if (isNaN(number)) return '0,00 €';
    return number.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
};

const safeText = (text) => (text ? String(text) : '---');

// JARVIS: ESTILOS BLINDADOS Y TABLA AJUSTADA
const styles = StyleSheet.create({
    page: { fontFamily: 'Helvetica', fontSize: 10, padding: 30, paddingBottom: 40, color: '#333' },
    header: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 15, paddingBottom: 10, borderBottomWidth: 1, borderBottomColor: '#eaeaea' },
    companyDetails: { maxWidth: '45%' },
    companyName: { fontSize: 12, fontWeight: 'bold', color: '#2C3E50' },
    companyInfo: { fontSize: 9, color: '#555', marginTop: 2 },
    logoContainer: { width: '50%', alignItems: 'flex-end' },
    logo: { width: 60, height: 60, marginBottom: 5 },
    docTitle: { fontSize: 18, fontWeight: 'bold', color: '#2C3E50' },
    docInfo: { fontSize: 9, color: '#555' },
    
    clientSection: { marginTop: 10, marginBottom: 15, padding: 8, backgroundColor: '#f9f9f9', borderRadius: 5 },
    sectionTitle: { fontSize: 10, fontWeight: 'bold', marginBottom: 5, color: '#18BC9C', textTransform: 'uppercase' },
    clientText: { fontSize: 9, marginBottom: 2 },
    
    // 🔥 JARVIS: ESTILOS NUEVOS PARA ALERTAS DE TALLER
    tallerGlobalBox: { marginTop: 5, marginBottom: 15, padding: 8, backgroundColor: '#fffbeb', borderLeftWidth: 3, borderLeftColor: '#d97706', borderRadius: 2 },
    tallerGlobalTitle: { fontSize: 9, fontWeight: 'bold', color: '#b45309', marginBottom: 4, textTransform: 'uppercase' },
    tallerGlobalText: { fontSize: 9, color: '#92400e', lineHeight: 1.3 },
    tallerLineNote: { fontSize: 8, color: '#d97706', fontStyle: 'italic', marginTop: 3, paddingLeft: 4, borderLeftWidth: 1, borderLeftColor: '#fcd34d' },

    table: { width: '100%', borderWidth: 1, borderColor: '#eaeaea', borderRadius: 4, marginBottom: 15 },
    tableHeader: { flexDirection: 'row', backgroundColor: '#18BC9C', borderBottomWidth: 1, borderBottomColor: '#18BC9C' },
    tableRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#eee', alignItems: 'stretch' },
    
    colFull: { width: '100%', padding: 8 },
    colDescClient: { width: '70%', padding: 8, borderRightWidth: 1, borderRightColor: '#eee' }, 
    colDescTaller: { width: '85%', padding: 8, borderRightWidth: 1, borderRightColor: '#eee' },
    colCant: { width: '15%', padding: 8, borderRightWidth: 1, borderRightColor: '#eee', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' },
    colTotal: { width: '15%', padding: 8, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end' },
    
    tableCellHeader: { fontSize: 9, fontWeight: 'bold', color: 'white', textAlign: 'center' },
    tableCell: { fontSize: 8, lineHeight: 1.3 },
    tableCellDesc: { fontSize: 8, lineHeight: 1.3, textAlign: 'justify', color: '#333' },

    footerSection: { marginTop: 15, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' },
    
    desglosePagoBox: { width: '45%', padding: 8, borderLeftWidth: 3, borderLeftColor: '#18BC9C', backgroundColor: '#fcfcfc' },
    desgloseTitle: { fontSize: 8, fontWeight: 'bold', color: '#2C3E50', marginBottom: 4, textTransform: 'uppercase' },
    desgloseRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 2 },
    desgloseLabel: { fontSize: 7.5, color: '#555' },
    desgloseValue: { fontSize: 7.5, fontWeight: 'bold', color: '#333' },

    summaryBox: { width: '45%' },
    summaryRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4, paddingVertical: 2, borderBottomWidth: 1, borderBottomColor: '#eaeaea' },
    summaryLabel: { color: '#555', fontSize: 9 },
    summaryValue: { fontWeight: 'bold', fontSize: 9 },
    totalRow: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 4, paddingTop: 4, borderTopWidth: 2, borderTopColor: '#18BC9C' },
    totalLabel: { fontWeight: 'bold', fontSize: 11 },
    totalValue: { fontWeight: 'bold', fontSize: 11, color: '#18BC9C' },
    
    condicionesBox: { marginTop: 15, paddingTop: 8, borderTopWidth: 1, borderTopColor: '#eaeaea' },
    condicionesTitle: { fontSize: 9, fontWeight: 'bold', color: '#2C3E50', marginBottom: 4, textTransform: 'uppercase' },
    condicionesText: { fontSize: 8, color: '#555', marginBottom: 1 },
    
    internoBox: { marginTop: 15, padding: 8, backgroundColor: '#f0fdf4', borderLeftWidth: 3, borderLeftColor: '#16a34a' },
    internoTitle: { fontSize: 9, fontWeight: 'bold', color: '#166534', marginBottom: 4, textTransform: 'uppercase' },
    internoText: { fontSize: 8, color: '#15803d', marginBottom: 2 },
    internoTotal: { fontSize: 9, fontWeight: 'bold', color: '#16a34a', marginTop: 4, paddingTop: 4, borderTopWidth: 1, borderTopColor: '#bbf7d0' },

    footer: { marginTop: 20, paddingTop: 8, borderTopWidth: 1, borderTopColor: '#eaeaea', alignItems: 'center', justifyContent: 'center' },
    footerText: { fontSize: 9, fontWeight: 'bold', color: '#18BC9C', textTransform: 'uppercase', letterSpacing: 1 }
});

const PresupuestoPDF_V2 = ({ presupuesto, type }) => {
    if (!presupuesto || Object.keys(presupuesto).length === 0) {
        return (
            <Document><Page size="A4" style={styles.page}><Text>{"Cargando..."}</Text></Page></Document>
        );
    }

    const isTaller = type === 'taller';
    const esParaCliente = type === 'presupuesto' || type === 'orden'; 
    const isInterno = type === 'interno'; 

    const fechaFormateada = presupuesto.fecha ? new Date(presupuesto.fecha).toLocaleDateString('es-ES') : '---';
    const c = presupuesto.cliente || presupuesto.datosCliente || {};
    const descripcionTexto = safeText(presupuesto.descripcion || presupuesto.descripcionPresupuesto);

    const tieneBloques = Array.isArray(presupuesto.bloques) && presupuesto.bloques.length > 0;

    let subtotalVisible = parseFloat(
        presupuesto.totales?.subtotalParaPDF || 
        presupuesto.calculos?.totales?.subtotalParaPDF || 
        presupuesto.calculos?.subtotalParaPDF
    ) || 0;

    let totalVenta = parseFloat(
        presupuesto.totales?.totalGeneral || 
        presupuesto.calculos?.totales?.totalGeneral || 
        presupuesto.calculos?.totalGeneral || 
        presupuesto.total
    ) || 0;
    
    if (subtotalVisible === 0 && totalVenta === 0 && Array.isArray(presupuesto.lineas) && presupuesto.lineas.length > 0) {
        const sumaLineas = presupuesto.lineas.reduce((acc, l) => acc + (parseFloat(l.total) || 0), 0);
        const comision = (sumaLineas * (parseFloat(presupuesto.calculos?.comision) || parseFloat(presupuesto.calculos?.comisionVendedor) || 10)) / 100;
        const flete = parseFloat(presupuesto.calculos?.costoFlete) || parseFloat(presupuesto.costoFlete) || 0;
        const inst = parseFloat(presupuesto.calculos?.costoInstalacion) || parseFloat(presupuesto.costoInstalacion) || 0;
        
        subtotalVisible = sumaLineas + comision + flete + inst;
        const transporteEmergencia = parseFloat(presupuesto.calculos?.transporteManualResumen) || parseFloat(presupuesto.transporteManualResumen) || 0;
        const baseEmergencia = subtotalVisible + transporteEmergencia;
        totalVenta = baseEmergencia * 1.21;
    } else if (subtotalVisible === 0 && totalVenta > 0) {
        subtotalVisible = totalVenta / 1.21;
    }

    const transporte = parseFloat(presupuesto.calculos?.transporteManualResumen || presupuesto.transporteManualResumen) || 0;
    
    let iva = Math.max(0, totalVenta - subtotalVisible - transporte);
    
    if (iva === 0 && totalVenta > 0) {
        iva = (subtotalVisible + transporte) * 0.21;
    }

    // 🔥 JARVIS: LÓGICA DE PRORRATEO (LICUAR COSTOS INVISIBLES EN EL PRECIO UNITARIO)
    let sumaTotalLineasBase = 0;
    if (tieneBloques) {
        sumaTotalLineasBase = presupuesto.bloques.reduce((acc, b) => acc + (b.lineas || []).reduce((a, l) => a + (parseFloat(l.total) || 0), 0), 0);
    } else if (Array.isArray(presupuesto.lineas)) {
        sumaTotalLineasBase = presupuesto.lineas.reduce((acc, l) => acc + (parseFloat(l.total) || 0), 0);
    }
    const factorProrrateo = sumaTotalLineasBase > 0 ? (subtotalVisible / sumaTotalLineasBase) : 1;

    // 🔥 JARVIS: CÁLCULO MATEMÁTICO DINÁMICO DE DESGLOSE DE PAGO (A PRUEBA DE FALLOS)
    const condicionesArray = Array.isArray(presupuesto.condicionesSeleccionadas) 
        ? presupuesto.condicionesSeleccionadas 
        : (Array.isArray(presupuesto.condiciones) ? presupuesto.condiciones : []);

    let desgloseCalculado = presupuesto.calculos?.desglosePago || presupuesto.desglosePago;

    condicionesArray.forEach(cond => {
        if (typeof cond === 'string') {
            const cLow = cond.toLowerCase();
            if (cLow.includes('70%') && cLow.includes('30%')) {
                desgloseCalculado = { tipo: '70/30', anticipoPct: 70, entregaPct: 30, anticipoMonto: totalVenta * 0.70, entregaMonto: totalVenta * 0.30 };
            } else if (cLow.includes('50%') && cLow.includes('anticipo')) {
                desgloseCalculado = { tipo: '50/50', anticipoPct: 50, entregaPct: 50, anticipoMonto: totalVenta * 0.50, entregaMonto: totalVenta * 0.50 };
            } else if (cLow.includes('60%') && cLow.includes('40%')) {
                desgloseCalculado = { tipo: '60/40', anticipoPct: 60, entregaPct: 40, anticipoMonto: totalVenta * 0.60, entregaMonto: totalVenta * 0.40 };
            }
        }
    });

    const listaFinalCondiciones = [];
    const cant = presupuesto.tiempoEntrega?.cantidad || '2';
    const unidad = presupuesto.tiempoEntrega?.unidad || 'semanas';
    
    listaFinalCondiciones.push(`Plazo de entrega: ${cant} ${unidad}`);

    if (desgloseCalculado) {
        listaFinalCondiciones.push(`Forma de pago: ${desgloseCalculado.anticipoPct}% anticipo y ${desgloseCalculado.entregaPct}% a la entrega`);
    }

    condicionesArray.forEach(cond => {
        if (typeof cond === 'string') {
            const cLow = cond.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            if (
                !cLow.includes("plazo de entrega") && 
                !cLow.includes("semanas") && 
                !cLow.includes("forma de pago") &&
                !cLow.includes("15 dias") &&
                !cLow.includes("valido por") &&
                !cLow.includes("70%") &&
                !cLow.includes("60%") &&
                !cLow.includes("50%")
            ) {
                listaFinalCondiciones.push(cond);
            }
        }
    });

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                    <View style={styles.companyDetails}>
                        <Text style={styles.companyName}>{"Scarjav.SL"}</Text>
                        <Text style={styles.companyInfo}>{"CIF: B22518393"}</Text>
                        <Text style={styles.companyInfo}>{"Calle Pablo Tejera Num 37, 28229 Madrid"}</Text>
                        <Text style={styles.companyInfo}>{"hoppytimeofplaymas@gmail.com"}</Text>
                    </View>
                    <View style={styles.logoContainer}>
                        {miLogo ? <Image style={styles.logo} src={miLogo} /> : null}
                        <Text style={styles.docTitle}>{safeText(type).toUpperCase()}</Text>
                        <Text style={styles.docInfo}>{`Ref: ${safeText(presupuesto.numero)}`}</Text>
                        <Text style={styles.docInfo}>{`Fecha: ${fechaFormateada}`}</Text>
                    </View>
                </View>

                <View style={styles.clientSection}>
                    <Text style={styles.sectionTitle}>{"DATOS DEL CLIENTE"}</Text>
                    <Text style={styles.clientText}>{safeText(c.name)}</Text>
                    {c.nif ? <Text style={styles.clientText}>{`NIF/CIF: ${safeText(c.nif)}`}</Text> : null}
                    {c.direccion ? <Text style={styles.clientText}>{`Dir: ${safeText(c.direccion)}`}</Text> : null}
                    {(c.codPostal || c.poblacion) ? <Text style={styles.clientText}>{`${safeText(c.codPostal)} ${safeText(c.poblacion)}`.trim()}</Text> : null}
                    {c.telefono ? <Text style={styles.clientText}>{`Tel: ${safeText(c.telefono)}`}</Text> : null}
                    {c.email ? <Text style={styles.clientText}>{`Email: ${safeText(c.email)}`}</Text> : null}
                </View>

                {/* 🔥 JARVIS: RENDERIZADO DE NOTAS GENERALES EXCLUSIVO PARA TALLER */}
                {isTaller && presupuesto.notasTallerGlobal ? (
                    <View style={styles.tallerGlobalBox}>
                        <Text style={styles.tallerGlobalTitle}>{"NOTAS GENERALES DE PRODUCCIÓN"}</Text>
                        <Text style={styles.tallerGlobalText}>{safeText(presupuesto.notasTallerGlobal)}</Text>
                    </View>
                ) : null}

                <View style={styles.table}>
                    <View style={styles.tableHeader} fixed>
                        <View style={isTaller ? styles.colDescTaller : styles.colDescClient}>
                            <Text style={{...styles.tableCellHeader, textAlign: 'left'}}>{esParaCliente ? 'Descripción / Concepto' : 'Producto / Partida'}</Text>
                        </View>
                        <View style={styles.colCant}>
                            <Text style={styles.tableCellHeader}>{"Cant."}</Text>
                        </View>
                        {!isTaller ? (
                            <View style={styles.colTotal}>
                                <Text style={{...styles.tableCellHeader, textAlign: 'right'}}>{"Total"}</Text>
                            </View>
                        ) : null}
                    </View>

                    {esParaCliente ? (
                        /* JARVIS: MODO CLIENTE - MÁXIMA PRIVACIDAD Y PRORRATEO DE COSTOS */
                        tieneBloques ? (
                            presupuesto.bloques.map((bloque, index) => {
                                const subtotalBloqueBase = (bloque.lineas || []).reduce((acc, l) => acc + (parseFloat(l.total) || 0), 0);
                                // Inflamos el bloque con el factor para que asuma la comisión y la instalación
                                const subtotalBloqueInflado = subtotalBloqueBase * factorProrrateo;
                                
                                return (
                                    <View style={styles.tableRow} key={`cli-block-${index}`} wrap={false}>
                                        <View style={styles.colDescClient}>
                                            <Text style={styles.tableCellDesc}>{safeText(bloque.descripcion || "Servicio detallado")}</Text>
                                        </View>
                                        <View style={styles.colCant}>
                                            <Text style={styles.tableCell}>{"1"}</Text>
                                        </View>
                                        <View style={styles.colTotal}>
                                            <Text style={{...styles.tableCell, fontWeight: 'bold'}}>{formatCurrency(subtotalBloqueInflado)}</Text>
                                        </View>
                                    </View>
                                );
                            })
                        ) : (
                            <View style={styles.tableRow} wrap={false}>
                                <View style={styles.colDescClient}>
                                    <Text style={styles.tableCellDesc}>{descripcionTexto}</Text>
                                </View>
                                <View style={styles.colCant}>
                                    <Text style={styles.tableCell}>{"1"}</Text>
                                </View>
                                <View style={styles.colTotal}>
                                    <Text style={{...styles.tableCell, fontWeight: 'bold'}}>{formatCurrency(subtotalVisible)}</Text>
                                </View>
                            </View>
                        )
                    ) : (
                        /* JARVIS: MODO INTERNO/TALLER - MUESTRA TODO EL DESGLOSE PRIVADO (COSTOS BASE) */
                        tieneBloques ? (
                            presupuesto.bloques.map((bloque, index) => {
                                const lineasFiltradas = (bloque.lineas || []).filter(line => {
                                    const desc = (line.producto || line.descripcion || "").toLowerCase();
                                    return !desc.includes("semanas") && !desc.includes("entrega");
                                });
                                const subtotalBloque = (bloque.lineas || []).reduce((acc, l) => acc + (parseFloat(l.total) || 0), 0);

                                return (
                                    <View key={`int-block-${index}`}>
                                        <View style={{flexDirection: 'row', backgroundColor: '#f4fbf9', borderBottomWidth: 1, borderBottomColor: '#18BC9C', padding: 6}}>
                                            <View style={{width: '100%'}}>
                                                <Text style={{fontSize: 9, fontWeight: 'bold', color: '#18BC9C', textTransform: 'uppercase'}}>{safeText(bloque.descripcion || `Sección ${index + 1}`)}</Text>
                                            </View>
                                        </View>
                                        {lineasFiltradas.length > 0 ? (
                                            lineasFiltradas.map((line, lIndex) => (
                                                <View style={styles.tableRow} key={`line-${index}-${lIndex}`} wrap={false}>
                                                    <View style={isTaller ? styles.colDescTaller : styles.colDescClient}>
                                                        <Text style={styles.tableCellDesc}>{safeText(line.producto || line.descripcion)}</Text>
                                                        {/* 🔥 JARVIS: NOTAS POR PARTIDA EXCLUSIVAS DE TALLER */}
                                                        {isTaller && line.notasTaller ? (
                                                            <Text style={styles.tallerLineNote}>{`Modificación: ${safeText(line.notasTaller)}`}</Text>
                                                        ) : null}
                                                    </View>
                                                    <View style={styles.colCant}>
                                                        <Text style={styles.tableCell}>{String(line.cantidad || "0")}</Text>
                                                    </View>
                                                    {!isTaller ? (
                                                        <View style={styles.colTotal}>
                                                            <Text style={styles.tableCell}>{formatCurrency(line.total)}</Text>
                                                        </View>
                                                    ) : null}
                                                </View>
                                            ))
                                        ) : (
                                            <View style={styles.tableRow} wrap={false}>
                                                <View style={styles.colFull}>
                                                    <Text style={{...styles.tableCellDesc, fontStyle: 'italic', color: '#999', textAlign: 'center'}}>{"Sin partidas registradas"}</Text>
                                                </View>
                                            </View>
                                        )}
                                        {!isTaller ? (
                                            <View style={{flexDirection: 'row', justifyContent: 'flex-end', padding: 6, backgroundColor: '#fafafa', borderBottomWidth: 1, borderBottomColor: '#eee'}}>
                                                <Text style={{fontSize: 9, fontWeight: 'bold', color: '#555', marginRight: 10}}>{"Subtotal:"}</Text>
                                                <Text style={{fontSize: 9, fontWeight: 'bold', color: '#18BC9C'}}>{formatCurrency(subtotalBloque)}</Text>
                                            </View>
                                        ) : null}
                                    </View>
                                );
                            })
                        ) : (
                            (presupuesto.lineas || [])
                                .filter(line => {
                                    const desc = (line.producto || line.descripcion || "").toLowerCase();
                                    return !desc.includes("semanas") && !desc.includes("entrega");
                                })
                                .map((line, index) => (
                                    <View style={styles.tableRow} key={`old-int-line-${index}`} wrap={false}>
                                        <View style={isTaller ? styles.colDescTaller : styles.colDescClient}>
                                            <Text style={styles.tableCellDesc}>{safeText(line.producto || line.descripcion)}</Text>
                                            {/* 🔥 JARVIS: NOTAS POR PARTIDA EXCLUSIVAS DE TALLER (CASO SIN BLOQUES) */}
                                            {isTaller && line.notasTaller ? (
                                                <Text style={styles.tallerLineNote}>{`Modificación: ${safeText(line.notasTaller)}`}</Text>
                                            ) : null}
                                        </View>
                                        <View style={styles.colCant}>
                                            <Text style={styles.tableCell}>{String(line.cantidad || "0")}</Text>
                                        </View>
                                        {!isTaller ? (
                                            <View style={styles.colTotal}>
                                                <Text style={styles.tableCell}>{formatCurrency(line.total)}</Text>
                                            </View>
                                        ) : null}
                                    </View>
                                ))
                        )
                    )}
                </View>

                {!isTaller ? (
                    <View style={styles.footerSection}>
                        {esParaCliente && desgloseCalculado ? (
                            <View style={styles.desglosePagoBox}>
                                <Text style={styles.desgloseTitle}>{`Plan de Pago (${safeText(desgloseCalculado.tipo)})`}</Text>
                                <View style={styles.desgloseRow}>
                                    <Text style={styles.desgloseLabel}>{`Anticipo (${desgloseCalculado.anticipoPct}%):`}</Text>
                                    <Text style={styles.desgloseValue}>{formatCurrency(desgloseCalculado.anticipoMonto)}</Text>
                                </View>
                                <View style={styles.desgloseRow}>
                                    <Text style={styles.desgloseLabel}>{`A la entrega (${desgloseCalculado.entregaPct}%):`}</Text>
                                    <Text style={styles.desgloseValue}>{formatCurrency(desgloseCalculado.entregaMonto)}</Text>
                                </View>
                            </View>
                        ) : <View style={{width: '45%'}} />}

                        <View style={styles.summaryBox}>
                            <View style={styles.summaryRow}>
                                <Text style={styles.summaryLabel}>{"Subtotal (Base):"}</Text>
                                <Text style={styles.summaryValue}>{formatCurrency(subtotalVisible)}</Text>
                            </View>
                            {transporte > 0 ? (
                                <View style={styles.summaryRow}>
                                    <Text style={styles.summaryLabel}>{"Transporte:"}</Text>
                                    <Text style={styles.summaryValue}>{formatCurrency(transporte)}</Text>
                                </View>
                            ) : null}
                            <View style={styles.summaryRow}>
                                <Text style={styles.summaryLabel}>{"IVA (21%):"}</Text>
                                <Text style={styles.summaryValue}>{formatCurrency(iva)}</Text>
                            </View>
                            <View style={styles.totalRow}>
                                <Text style={styles.totalLabel}>{"TOTAL VENTA:"}</Text>
                                <Text style={styles.totalValue}>{formatCurrency(totalVenta)}</Text>
                            </View>
                        </View>
                    </View>
                ) : null}

                {esParaCliente ? (
                    <View style={styles.condicionesBox}>
                        <Text style={styles.condicionesTitle}>{"Condiciones y Forma de Pago"}</Text>
                        
                        {listaFinalCondiciones.map((cond, i) => (
                            <Text key={`cond-${i}`} style={styles.condicionesText}>{`• ${cond}`}</Text>
                        ))}
                    </View>
                ) : null}

                {isInterno ? (
                    <View style={styles.internoBox}>
                        <Text style={styles.internoTitle}>{"ANÁLISIS INTERNO (CONFIDENCIAL)"}</Text>
                        <Text style={styles.internoText}>{`Coste Materiales: ${formatCurrency(presupuesto.calculos?.totales?.materiales || 0)}`}</Text>
                        <Text style={styles.internoText}>{`Mano Obra Carpintería: ${formatCurrency(presupuesto.calculos?.totales?.manoObraCarpinteria || 0)}`}</Text>
                        <Text style={styles.internoText}>{`Mano Obra Tapicería: ${formatCurrency(presupuesto.calculos?.totales?.manoObraTapiceria || 0)}`}</Text>
                        <Text style={styles.internoText}>{`Gastos Fijos: ${formatCurrency(presupuesto.calculos?.gastosFijos || 0)}`}</Text>
                        <Text style={styles.internoText}>{`Flete/Transporte Coste: ${formatCurrency(presupuesto.calculos?.costoFlete || presupuesto.costoFlete || 0)}`}</Text>
                        <Text style={styles.internoText}>{`Instalación Coste: ${formatCurrency(presupuesto.calculos?.costoInstalacion || presupuesto.costoInstalacion || 0)}`}</Text>
                        <Text style={styles.internoTotal}>{`COSTE TOTAL EGRESO: ${formatCurrency(presupuesto.calculos?.egreso || 0)}`}</Text>
                        <Text style={{...styles.internoTotal, fontSize: 10, color: '#14532d'}}>{`BENEFICIO ESTIMADO: ${formatCurrency(presupuesto.calculos?.restante || 0)}`}</Text>
                    </View>
                ) : null}

                <View style={styles.footer}><Text style={styles.footerText}>{"GRACIAS POR SU CONFIANZA"}</Text></View>
            </Page>
        </Document>
    );
};

export default PresupuestoPDF_V2;